<template>

  <div class="auction_w ">

    <CardHead >
      <div slot="title" class="card_title fz20 c_1A1A1A font_w_bold">交易项目</div>
      <div slot="oper"><router-link class="c_1A1A1A" to="/project">更多 >></router-link></div>
    </CardHead>

    <div class="content_w">
      <el-table
        :data="projectData"
        style="width: 100%;box-shadow: 0 0 10px 5px #ebeef5;font-size: 16px;"
        stripe
        highlight-current-row
        :header-cell-style="{'backgroundColor': '#0983cc','color':'#fff'}"
      >
        <el-table-column
          prop="projectNo"
          label="项目编号"
          show-overflow-tooltip
          header-align="center"
          align="center"
        />
        <el-table-column
          prop="title"
          label="项目名称"
          show-overflow-tooltip
          header-align="center"
          align="center"
        />
        <el-table-column
          prop="quantity"
          label="面积/数量"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.quantity }}{{ scope.row.quantityUnitName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="currentPrice"
          label="当前价"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            ￥{{ scope.row.currentPrice }}元<em class="" v-show="scope.row.priceUnitDesc">{{'/'+scope.row.priceUnitDesc}}</em>
          </template>
        </el-table-column>
        <el-table-column
          prop="onlineAt"
          label="发布时间"
          show-overflow-tooltip
          header-align="center"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button class="detail_btn c_0983CC fz16" type="text" size="mini" @click="onGoProjectItem(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
import { project_home } from '@/api/portal'
import CardHead from '@/components/template/CardHead.vue'
import {uuid} from '@/utils'
export default {
  components:{
    CardHead
  },
  data() {
    return {
      projectData: []
    }
  },
  computed:{
    ...mapGetters(['priceUnitKey'])
  },
  created() {
    this.getProjectData()
  },
  methods: {
    // 获取竞拍列表 api
    async getProjectData() {
      const { data } = await project_home({
        rows: 10,
        uid: uuid(13),
      })
      console.log('getProjectData',data)
      this.projectData = data
    },
    // 跳转项目详情 click
    onGoProjectItem(row){
      this.$router.push(
        {
          name:'projectDetail',
          query:{
            projectNo: row.projectNo
          }
        }
      );
    },
  }
}
</script>

<style lang="scss" scoped>
.auction_w{
    .content_w{
        margin: 20px 0;
    }
    .detail_btn{
      // background-color: #0983cc;
      // border-color: #0983cc;
      // &:hover{
      //   background-color: rgba($color: #0983cc, $alpha: .9);
      //   border-color: rgba($color: #0983cc, $alpha: .9);
      // }
      // &:active{
      //   background-color: #0772b2;
      // }
    }

}
::v-deep .el-table__body tr.hover-row>td.el-table__cell{
          color: #0983cc;
}
</style>
